<template>
    <div class="editor-light-control" :class="{ 'editor-light-control--disabled': disabled }">
        <SmallPlayer v-if="!adding" :src="bookpart.audio" sync />
        <button
            v-if="!adding"
            v-tooltip="'Play whole text from this sentence'"
            class="button button--blank"
            type="button"
            @click="play"
        >
            <svg
                fill="#a6a7be"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g id="SVGRepo_bgCarrier" stroke-width="0" />
                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" />
                <g id="SVGRepo_iconCarrier">
                    <path
                        d="M8,7,2,11V3ZM3,14.5H21a1,1,0,0,0,0-2H3a1,1,0,0,0,0,2ZM10,7a1,1,0,0,0,1,1H21a1,1,0,0,0,0-2H11A1,1,0,0,0,10,7ZM3,21H21a1,1,0,0,0,0-2H3a1,1,0,0,0,0,2Z"
                    />
                </g>
            </svg>
        </button>
        <button
            :title="bookpart.speaker.name.eng"
            type="button"
            class="button button--blank editor-light-control__speaker"
            @click="showSpeakersModal = true"
        >
            {{ truncate(bookpart.speaker.name.eng, 10) }}
        </button>
        <portal v-if="showSpeakersModal" to="modals">
            <SpeakersModal
                v-model="speaker"
                :language="language"
                :limit="$store.state.book.book.limit"
                @close="showSpeakersModal = false"
                @update:model-value="showSpeakersModal = false"
            />
        </portal>
    </div>
</template>

<script>
import SpeakersModal from '../SpeakersModal/SpeakersModal.vue';
import { SmallPlayer } from '@speechki-frontend/shared/ui/Player';

import { truncate } from '@speechki-frontend/shared/helpers/functions';

export default {
    name: 'EditorLightSentenceControl',
    components: {
        SpeakersModal,
        SmallPlayer,
    },
    emits: ['update:modelValue', 'play'],
    props: {
        bookpart: {
            type: Object,
            required: true,
        },
        adding: {
            type: Boolean,
            default: false,
        },
        playing: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            showSpeakersModal: false,
            speaker: this.bookpart.speaker.id,
            language: this.bookpart.speaker.language,
        };
    },

    watch: {
        speaker() {
            this.$emit('update:modelValue', this.speaker);
        },
    },

    methods: {
        truncate,
        play() {
            this.$emit('play');
        },
    },
};
</script>
